import { render, staticRenderFns } from "./PendingTransactionDetailCard.vue?vue&type=template&id=50c34a06&"
import script from "./PendingTransactionDetailCard.vue?vue&type=script&lang=js&"
export * from "./PendingTransactionDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./PendingTransactionDetailCard.vue?vue&type=style&index=0&id=50c34a06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports